/**
 * @generated SignedSource<<2e7129da258d7f97197da7bb9e03da48>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type salesChannelDeleteMiniSiteMutation$variables = {
  id: string;
};
export type salesChannelDeleteMiniSiteMutation$data = {
  readonly deleteStandaloneSite: boolean;
};
export type salesChannelDeleteMiniSiteMutation = {
  response: salesChannelDeleteMiniSiteMutation$data;
  variables: salesChannelDeleteMiniSiteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteStandaloneSite",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelDeleteMiniSiteMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelDeleteMiniSiteMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "401b8abf5475db80836de469b8eb8fe5",
    "id": null,
    "metadata": {},
    "name": "salesChannelDeleteMiniSiteMutation",
    "operationKind": "mutation",
    "text": "mutation salesChannelDeleteMiniSiteMutation(\n  $id: ID!\n) {\n  deleteStandaloneSite(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "4e0b5a34d175e473181834833940f23b";

export default node;
